import { SVGProps } from './types';

const FilterIcon = (props: SVGProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 8H12M2 4H14M6 12H10"
        stroke="#57524D"
        stroke-width="1.16667"
        stroke-linecap="square"
      />
    </svg>
  );
};

export { FilterIcon };
